module.exports = __webpack_public_path__ + "static/media/8.d4809d46.png";